import { bootstrapApplication } from '@angular/platform-browser';
import { loadRuntimeAuthConfig } from './app/core/auth/runtime-auth-config';

loadRuntimeAuthConfig(document.baseURI)
  .then(async () => {
    const [{ appConfig }, { AppComponent }] = await Promise.all([
      import('./app/app.config'), import('./app/app.component')
    ]);
    return bootstrapApplication(AppComponent, appConfig);
  })
  .catch(() => {
    // Keep configuration values, tokens and exception details out of the page/logs.
    const message = document.createElement('p');
    message.setAttribute('role', 'alert');
    message.textContent = 'OpenFLIS could not load. Please refresh the page. If this continues, contact support@openflis.com.';
    document.querySelector('app-root')?.replaceChildren(message);
  });
